module.exports = __webpack_public_path__ + "img/rinse-fm.32621a2c.png";